/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFlashOn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 15H1.89L13 1.199V9h9.11L11 22.801zm0-8.199L6.11 13H13v4.199L17.89 11H11z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFlashOn as FlashOn };
